import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/debug',
      name: 'Debug',
      component: Main
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js